import { FloatingLabelForm } from "components/RenderInput"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"

export const setInitialAccounts = connectedAccountsConfig => {
  let mainAcc = null
  let mpAcc = null
  let accounts = [...connectedAccountsConfig]
  for (let i = 0; i < connectedAccountsConfig?.length; i++) {
    if (connectedAccountsConfig[i]?.main_account) {
      mainAcc = connectedAccountsConfig[i]
    }
    if (!connectedAccountsConfig[i]?.stripe_connected_account_id) {
      mpAcc = connectedAccountsConfig[i]
    }
  }
  for (let i = 0; i < accounts?.length; i++) {
    if (mainAcc && accounts[i]?.id === mainAcc?.id) {
      accounts?.splice(i, 1)
    }
  }
  for (let i = 0; i < accounts?.length; i++) {
    if (mpAcc && accounts[i]?.id === mpAcc?.id) {
      accounts?.splice(i, 1)
    }
  }
  return {
    mainAcc,
    mpAcc,
    accounts,
  }
}

const isAlreadyConfigured = (payouts, account) => {
  let configured = false
  payouts?.forEach(payout => {
    if (account?.account_id == payout?.account_id) {
      configured = true
    }
  })
  return configured
}

export const setInitialStripeAccounts = (connectedAccountsList, payouts) => {
  let mainAcc = null
  let accounts = [...connectedAccountsList]
  for (let i = 0; i < accounts?.length; i++) {
    if (accounts[i]?.main_account) {
      mainAcc = accounts[i]
      accounts?.splice(i, 1)
    }
  }
  for (let i = 0; i < accounts?.length; i++) {
    if (isAlreadyConfigured(payouts, accounts[i])) {
      accounts?.splice(i, 1)
      i = i - 1
    }
  }

  return { mainAcc, accounts }
}

export const getDefaultPaymentConfigs = (vendorPaymentConfig, entity_type) => {
  let initialMpAccValues = { percentage: 0, fee: 0 }
  switch (entity_type) {
    case "booking_type":
      initialMpAccValues = {
        percentage: vendorPaymentConfig?.bookings_percentage,
        fee: vendorPaymentConfig?.bookings_fee,
      }
      break
    case "form_builder":
      initialMpAccValues = {
        percentage: vendorPaymentConfig?.form_builders_percentage,
        fee: vendorPaymentConfig?.form_builders_fee,
      }
      break
    default:
      initialMpAccValues = {
        percentage: vendorPaymentConfig?.products_percentage,
        fee: vendorPaymentConfig?.products_fee,
      }
  }

  return initialMpAccValues
}

export const selectAccount = (selectedAccount, stripeAccounts) => {
  let accounts = [...stripeAccounts]
  for (let i = 0; i < accounts?.length; i++) {
    if (accounts[i]?.account_id === selectedAccount?.account_id) {
      accounts.splice(i, 1)
    }
  }
  return {
    selected: {
      ...selectedAccount,
      percentage: 0,
      stripe_connected_acc_id: selectedAccount?.id,
    },
    accounts,
  }
}

export const removeAccount = (account, payouts) => {
  let accounts = [...payouts]
  for (let i = 0; i < accounts?.length; i++) {
    if (accounts[i]?.account_id === account?.account_id) {
      accounts.splice(i, 1)
    }
  }
  return {
    selected: {
      ...account,
      name: account?.account_name,
      percentage: null,
      fee: null,
    },
    accounts,
  }
}

export const renderClientAccounts = ({
  fields,
  meta: { error, submitFailed },
  updatePayouts,
  updateStripeAccounts,
  removeAccount,
  stripeAccounts,
}) => (
  <>
    {submitFailed && error && <span className={"input-error"}>{error}</span>}
    {fields.map((account, index) => {
      const accountValues = fields.get(index)
      return (
        <Row key={index} className="my-3">
          <Col xs="auto" xl={4} className="align-self-center">
            {accountValues &&
              (accountValues?.name || accountValues?.account_name) && (
                <span>
                  {accountValues?.name || accountValues?.account_name}
                  {"  "}
                </span>
              )}
            {accountValues && accountValues?.account_id && (
              <>
                (<b>ID:</b> <span> {accountValues?.account_id}</span>)
              </>
            )}
          </Col>
          <Col
            xs={5}
            sm={4}
            md={5}
            lg={4}
            xl={2}
            style={{ minWidth: "fit-content" }}
          >
            <Field
              name={`${account}.percentage`}
              component={FloatingLabelForm}
              placeholder="Percentage(%)"
              label="Percentage(%)"
              type="number"
              min="0"
              max="100"
            />
          </Col>
          <Col
            xs={5}
            sm={4}
            md={5}
            lg={4}
            xl={2}
            style={{ minWidth: "fit-content" }}
          >
            <Field
              name={`${account}.fee`}
              component={FloatingLabelForm}
              placeholder="Fee($)"
              label="Fee($)"
              type="number"
              step="0.1"
              min="0"
            />
          </Col>
          {!!accountValues?.amount && (
            <Col xs="auto" xl={1} className="align-self-center">
              ${accountValues?.amount}
            </Col>
          )}
          <Col xs="auto" className="align-self-center">
            <span
              style={{ color: "-webkit-link", cursor: "pointer" }}
              onClick={() => {
                const newValues = removeAccount(accountValues)
                updatePayouts(newValues?.accounts)
                updateStripeAccounts([...stripeAccounts, newValues?.selected])
                fields.remove(index)
              }}
            >
              <u>remove</u>
            </span>
          </Col>
        </Row>
      )
    })}
  </>
)

export const getTotalPercentage = (mainAccPercentage, accounts) => {
  let totalPercentage = parseInt(mainAccPercentage)
  accounts?.forEach(acc => {
    totalPercentage = totalPercentage + parseInt(acc?.percentage)
  })

  return totalPercentage
}

export const getTotalFees = (mainAccFee, accounts) => {
  let totalFee = parseFloat(mainAccFee)
  accounts?.forEach(acc => {
    let fee = acc?.fee || 0
    totalFee = totalFee + parseFloat(fee)
  })

  return totalFee
}

const getTotalAmountWithoutMpFees = (
  price = 0,
  mpPercentage = 0,
  mpFee = 0
) => {
  let total = 0

  total = (price - (price * mpPercentage) / 100 - mpFee)?.toFixed(2)

  return total
}

const getFixedFees = (clientAccounts = [], mainAccFee = 0) => {
  let fixedFees = 0

  for (let i = 0; i < clientAccounts?.length; i++) {
    fixedFees = fixedFees + parseFloat(clientAccounts[i]?.fee)
  }

  fixedFees = fixedFees + parseFloat(mainAccFee) || 0

  return fixedFees
}

export const calculateAmounts = formValues => {
  const price = formValues?.price || 0
  const mpPercentage = formValues?.percentage || 0
  const mpFee = formValues?.fee || 0
  const mainAccPercentage = formValues?.mainAccPercentage || 0
  const mainAccFee = formValues?.mainAccFee || 0
  const clientAccounts = formValues?.clientAccounts || []

  const total = getTotalAmountWithoutMpFees(price, mpPercentage, mpFee)

  const fixedFees = getFixedFees(clientAccounts, mainAccFee)

  const amountForPercentageSplit = total - fixedFees

  const mainAccAmount = (
    (amountForPercentageSplit * mainAccPercentage) / 100 +
    parseFloat(mainAccFee)
  ).toFixed(2)

  let clientAccountsWithAmounts = []
  for (let i = 0; i < clientAccounts?.length; i++) {
    let percentage = clientAccounts[i]?.percentage || 0
    let fee = parseFloat(clientAccounts[i]?.fee) || 0
    let amount = ((amountForPercentageSplit * percentage) / 100 + fee).toFixed(
      2
    )
    clientAccountsWithAmounts.push({
      ...clientAccounts[i],
      amount: amount,
    })
  }

  return { total, mainAccAmount, clientAccountsWithAmounts }
}

export const mapPayoutsAccountsToApi = (data, mainAccount) => {
  let accounts = [
    {
      id: mainAccount?.stripe_connected_acc_id,
      percentage: data?.mainAccPercentage || null,
      fee: data?.mainAccFee || null,
    },
    {
      id: null,
      percentage: data?.percentage || null,
      fee: data?.fee || null,
    },
  ]
  data?.clientAccounts?.forEach(acc => {
    accounts.push({
      id: acc?.stripe_connected_acc_id,
      percentage: acc?.percentage || null,
      fee: acc?.fee || null,
    })
  })

  return accounts
}
